import { DatePipe } from '@angular/common';
import is from '@angular/common/locales/extra/is';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { NativeDatetimeAdapter } from '../native-datetime-adapter';
import { DatetimeAdapter } from '../datetime-adapter';

@Component({
  selector: 'app-advanced-timings',
  templateUrl: './advanced-timings.component.html',
  styleUrls: ['./advanced-timings.component.css']
})
export class AdvancedTimingsComponent implements OnInit {

  formGroup: FormGroup;
  detect: boolean = true;
  date: FormControl = new FormControl();
  @ViewChild('picker') public picker: any | undefined;

  constructor(private datePipe: DatePipe,
    private datetimeAdapter: DatetimeAdapter<Date>) {
    this.formGroup = new FormGroup({
      date: this.date
    })
  }

  ngOnInit(): void {
    this.formGroup.valueChanges.subscribe(() => {
      if (this.detect) {
        this.detect = false;
        this._datetime = new Date(new Date(this.formGroup.controls.date.value).getTime());
        this.valueChange.emit(this._datetime);
        this.detect = true;
      }
    });

    this.populateForm();
  }

  @Input()
  get isUtc(): boolean {
    return this._isUtc;
  }
  set isUtc(value: boolean) {
    this._isUtc = value;
    if (this.formGroup) {
      this.populateForm();
    }
  }
  private _isUtc: boolean = true;

  @Input() showSeconds: boolean = true;

  @Input()
  label: string = "";

  @Input()
  placeholder: string = "";

  @Input()
  get value(): Date {
    return this._datetime;
  }
  set value(value: Date) {
    if (!this.detect) {
      return;
    }

    this.detect = false;
    if (value instanceof Date) {
      if (this.datetimeAdapter.compareDateWithTime(this._datetime, value, false) == 0) {
        this.detect = true;
        return;
      }

      this._datetime = value;
    }
    else {
      this.detect = true;
      throw new Error("Invalid Date:" + value);
    }

    if (this.formGroup) {
      this.populateForm();
    }
    this.detect = true;
  }
  private _datetime: Date = new Date();

  @Output() valueChange = new EventEmitter<Date>();

  @Input()
  get error(): boolean {
    return this._error;
  }
  set error(value: boolean) {
    this._error = value;
    if (this._error) {
      this.formGroup?.controls.date.setErrors({ 'invalid': 'Invalid Date' });
    }
    else {
      this.formGroup?.controls.date.setErrors({ 'invalid': ''});
    }
  }
  private _error: boolean = false;

  private populateForm() {
    if (this.formGroup == undefined) {
      this.detect = true;
      return;
    }

    this.detect = false;
    // const options: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit' };
    this.formGroup.controls.date.setValue(this._datetime); //.toLocaleDateString() + " " + this._datetime.toLocaleTimeString(undefined, options));
    this.detect = true;
  }

}
